module.exports = __webpack_public_path__ + "static/media/rahulaggarwal.5dda4065.jpg";